import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Css/style1.css";
import NavigateRoute from "./Routes";

function App() {
  return (
    <>
      <NavigateRoute />
    </>
  );
}

export default App;
